const formatTimestamp = (timestamp) => {
  if (!timestamp?.seconds) {
    console.warn("Timestamp invalid:", timestamp);
    return "Date is not valid";
  }

  const date = new Date(timestamp.seconds * 1000);

  const datePart = date.toLocaleDateString(undefined, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  const timePart = date.toLocaleTimeString(undefined, {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false, // set true if you want 12-hour format
  });

  return `${datePart} - ${timePart}`; // note the space instead of comma
};

export default formatTimestamp;
